/*
 * @Author: LiGang
 * @Date: 2024-05-13 18:42:27
 * @LastEditors: LG liganglig@outlook.com
 * @LastEditTime: 2024-08-28 16:31:55
 * @FilePath: /parkH5New/src/store/getters.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export const getters = {
  accessToken: state => state.accessToken.accessToken,
  isLoggedIn: state => state.accessToken.accessToken,
  userAccountPass: state => state.userAccountPass.userAccountPass,
  accountRole: state => state.accountRole.accountRole,
  openID: state => state.openID.openID,
  unionID: state => {
    if (state.unionID.unionID) {
      return state.unionID.unionID
    }
    const authInfo = state.wxZfbAuthInfo.wxZfbAuthInfo
    return (authInfo && authInfo.unionid) ? authInfo.unionid : ''
  },
  vhColumns (state) {
    console.log('state', state.myCarList)
    const arr = []
    if (state.myCarList.myCarList) {
      const list = state.myCarList.myCarList
      list.forEach(x => {
        arr.push(x.plate_number)
      })
    }

    return arr
  },
  thePayType: state => state.payType.payType,
  sid: state => state.sid.sid,
  queryLogHistory: state => state.queryLogHistory.queryLogHistory
}
